import { PageLoadError } from '@components/page-load-error';
import {
  getAccountsQueryOptions,
  getProductsQueryOptions,
} from '@features/accounts/api';
import { filterAccountsByType } from '@features/accounts/filterAccountsByType';
import { Account, Product } from '@features/accounts/types';
import { createFileRoute } from '@tanstack/react-router';
import AccountsPendingLayout from './-layouts/accounts-pending-layout';

export type AccountsPendingLoaderData = {
  pendingProductCount: number;
  hasNewlyPendingProducts: boolean;
  pendingProducts: Product[];
  savingsAccounts: Account[];
};

export const Route = createFileRoute(
  '/_authenticated/transfers/accounts-pending',
)({
  component: AccountsPendingLayout,
  errorComponent: ({ error }) => (
    <PageLoadError pageName='Accounts Pending' error={error} />
  ),
  loader: async ({ context }): Promise<AccountsPendingLoaderData> => {
    const products =
      context.queryClient.getQueryData(getProductsQueryOptions.queryKey) ??
      (await context.queryClient.fetchQuery(getProductsQueryOptions));

    const accounts =
      context.queryClient.getQueryData(getAccountsQueryOptions.queryKey) ??
      (await context.queryClient.fetchQuery(getAccountsQueryOptions));

    const pendingProducts = products?.savings.filter(
      (product) => product.pending,
    );

    const hasNewlyPendingProducts =
      products?.savings.some((product) => product.newlyPending) ?? false;

    const { savingsAccounts } = filterAccountsByType(accounts?.visible);

    return {
      pendingProductCount: pendingProducts?.length ?? 0,
      hasNewlyPendingProducts,
      pendingProducts,
      savingsAccounts: savingsAccounts,
    };
  },
});
